var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.525 18.025c-.333.216-.671.229-1.013.037-.341-.192-.512-.487-.512-.887V6.825c0-.4.17-.696.512-.888.342-.192.68-.179 1.013.038l8.15 5.175c.3.2.45.483.45.85s-.15.65-.45.85l-8.15 5.175z",
    fill: "#12385C"
  })));
}
export default SvgPlay2;